/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import KeepAliveRouterView from '@/components/KeepAliveRouterView.vue'
import {
  AgriculturalLoanContractListRouteName,
  AgriculturalLoanContractDetailRouteName,
  AgriculturalLoanApplyFormRouteName,
  AgriculturalLoanAddressSelectRouteName,
  AgriculturalLoanPackageSelectionRouteName,
  AgriculturalLoanDeviceListRouteName,
  AgriculturalLoanPowerOfAttorneyRouteName,
  AgriculturalLoanAgreementRouteName,
  AgriculturalLoanAppListRouteName,
  AgriculturalLoanAppFailRouteName,
} from '@/defination/constant'

const AgriculturalLoan = {
  path: '/agricultura-loan',
  name: 'agricultura-loan',
  redirect: { name: AgriculturalLoanAppListRouteName },
  component: KeepAliveRouterView,
  children: [
    {
      path: 'contract-list',
      name: AgriculturalLoanContractListRouteName,
      component: () =>
        import(
          /* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/contract-list.vue'
        ),
    },
    {
      path: 'contract-detail',
      name: AgriculturalLoanContractDetailRouteName,
      component: () =>
        import(
          /* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/contract-detail.vue'
        ),
    },
    {
      path: 'apply-form',
      name: AgriculturalLoanApplyFormRouteName,
      component: () =>
        import(
          /* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/apply-form.vue'
        ),
    },
    {
      path: 'address-select',
      name: AgriculturalLoanAddressSelectRouteName,
      component: () =>
        import(
          /* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/address-select.vue'
        ),
    },
    {
      path: 'package-selection',
      name: AgriculturalLoanPackageSelectionRouteName,
      component: () =>
        import(
          /* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/package-selection.vue'
        ),
    },
    {
      path: 'device-list',
      name: AgriculturalLoanDeviceListRouteName,
      component: () =>
        import(
          /* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/device-list.vue'
        ),
    },
    {
      path: 'power-of-attorney',
      name: AgriculturalLoanPowerOfAttorneyRouteName,
      component: () =>
        import(
          /* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/power-of-attorney.vue'
        ),
    },
    {
      path: 'agreement',
      name: AgriculturalLoanAgreementRouteName,
      component: () =>
        import(/* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/agreement.vue'),
    },
    {
      path: 'app-list',
      name: AgriculturalLoanAppListRouteName,
      component: () =>
        import(/* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/app-list.vue'),
    },
    {
      path: 'apply-fail',
      name: AgriculturalLoanAppFailRouteName,
      component: () =>
        import(
          /* webpackChunkName: "agricultura-loan" */ '@/views/agricultura-loan/apply-fail.vue'
        ),
    },
  ],
}
export default AgriculturalLoan
